import "maplibre-gl/dist/maplibre-gl.css";

import { Suspense } from "react";
import ReactDOM from "react-dom/client";

import "reflect-metadata";

import { AppBootstrapLoader, initMapLibreGl } from "@ryde/controls";
import {
  ApplicationType,
  gtm,
  i18nInitializedInstance,
  Log,
  setApplicationType,
} from "@ryde/shared";

import { AppRootSpa } from "./components/root";

initMapLibreGl();

setApplicationType(ApplicationType.Main);

const spaRootElement = document.getElementById("root") as HTMLElement | null;

gtm.init();
// this line is needed for initialization of i18n default instance
const i18nImported = i18nInitializedInstance;
Log.debug(`I18n initialized with language: ${i18nImported?.language}`);

if (spaRootElement) {
  const root = ReactDOM.createRoot(spaRootElement);
  // AppRootSpa reads translations; with no boundary above it, a synchronous re-render that suspends unmounts the app.
  // The fallback shows a spinner without text: it renders before any translation has arrived.
  root.render(
    <Suspense fallback={<AppBootstrapLoader />}>
      <AppRootSpa />
    </Suspense>,
  );
}
